import { flowRight } from 'lodash';
import { connect } from 'react-redux';
import { withCustomMetrics } from '@zocdoc/frontend-metrics';

import { getPendingSearchParameters } from '../../../Search/state';
import ThemedSearchPanel from './ThemedSearchPanel';
import { updateParameters } from '../../../Search/actions';

const mapStateToProps = state => {
    const pendingSearchParameters = getPendingSearchParameters(state);

    return {
        pendingSearchParameters,
    };
};


const mapDispatchToProps = {
    updateParameters,
};

export default flowRight(
    connect(mapStateToProps, mapDispatchToProps),
    withCustomMetrics({
        section: 'ThemedSearch',
        component: 'ThemedSearch',
        element: 'ThemedSearch',
    }),
)(ThemedSearchPanel);
